import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  ServiceProvidersService
} from '../../../shared';

@Component({
  selector: 'app-service-providers-edit',
  templateUrl: './service-providers-edit.component.html',
  styleUrls: ['./service-providers-edit.component.scss']
})
export class ServiceProvidersEditComponent implements OnInit {
  title = "EDIÇÃO DE PRESTADOR DE SERVIÇO";
  subtitle = "Utilize os campos abaixo para editar o prestador de serviço";
  urlBack = "/panel/service-providers/list";

  maskCnpj = "00.000.000/0000-00";

  editServiceProvider = new FormGroup({
    cdFornecedor: new FormControl('', Validators.required),
    cdFornecedorSap: new FormControl('', Validators.required),
    nmRazaoSocial: new FormControl('', Validators.required),
    nrCnpj: new FormControl('', Validators.required),
    nmFantasia: new FormControl('', Validators.required),
    nrInscrEstadual: new FormControl('', Validators.required),
    servicos: new FormControl(''),
    regioes: new FormControl(''),
    estados: new FormControl(''),
    areas: new FormControl('')
  });

  id;

  selectedRegions = [];
  selectedStates = [];
  checkboxActive = [];
  relationships = [
    {
      cdArea: "",
      dsArea: "",
      equipamentos: []
    }
  ];

  constructor(
    private headerService: HeaderService,
    private serviceProvidersService: ServiceProvidersService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
    private router: Router
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Edição do prestador de serviço');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.loadingBarService.start();

    this.serviceProvidersService.getServiceProvider(this.id).subscribe((response) => {
      this.editServiceProvider.patchValue({
        cdFornecedor: response['data'].cdFornecedor,
        cdFornecedorSap: response['data'].cdFornecedorSap,
        nmRazaoSocial: response['data'].nmRazaoSocial,
        nrCnpj: response['data'].nrCnpj,
        nmFantasia: response['data'].nmFantasia,
        nrInscrEstadual: response['data'].nrInscrEstadual,
        servicos: response['data'].servicos,
        regioes: response['data'].regioes,
        estados: response['data'].estados,
        areas: response['data'].areas
      });

      this.selectedRegions = response['data'].regioes;
      this.selectedStates = response['data'].estados;
      this.checkboxActive = response['data'].servicos;
      this.relationships = response['data'].areas;

      this.loadingBarService.complete();
    });
  }

  serviceValues(arr) {
    this.editServiceProvider.patchValue({
      servicos: arr
    });
  }

  regionsValues(arr) {
    this.editServiceProvider.patchValue({
      regioes: arr
    });
  }

  statesValues(arr) {
    this.editServiceProvider.patchValue({
      estados: arr
    });
  }

  equipmentsValues(arr) {
    this.editServiceProvider.patchValue({
      areas: arr
    });
  }

  updateServiceProvider() {
    this.loadingBarService.start();

    this.serviceProvidersService.editServiceProvider(this.editServiceProvider.value).subscribe((response) => {
      this.loadingBarService.complete();

      Swal({
        type: "success",
        title: "Prestador de serviço editado",
        text: "O prestador de serviço será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      });
    });
  }

}
